import axios from '@axios'
import store from '@/store'

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(dvr => ({
        value: dvr.id,
        label: dvr.name,
        id_unit: dvr?.id_unit ?? dvr?.unit?.id ?? dvr?.unit?.id_unit,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const response = await axios.get('v1/hanwha/dvr', {
        params,
        responseType: params?.action === 'export' ? 'blob' : 'json',
      })

      if (!response.data) {
        return []
      }

      if (params?.action === 'export') {
        const contentDisposition = response.headers['content-disposition'] || ''
        const fileName = contentDisposition.match(/filename\*?=(?:UTF-8''|["']?)([^;"']+)/i)?.[1]
          || 'hanwha-dvr.xlsx'
        const decodedFileName = decodeURIComponent(fileName.trim())
        const url = window.URL.createObjectURL(new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', decodedFileName)
        document.body.appendChild(link)
        link.click()
        link.remove()

        store.dispatch('grid/updateDownloadNotification', {
          id: decodedFileName,
          progress: 100,
          completed: true,
          view: 'hanwha-dvr',
          url,
          download: decodedFileName,
          title: 'Reporte de DVR Hanwha',
          body: 'Descarga completa',
          error: false,
          timestamp: `${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`,
        })
        return response.data
      }

      commit('setData', response.data.data)
      return response.data
    },
    async add(_, params) {
      const { data } = await axios.post('v1/hanwha/dvr', params)

      return data
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/hanwha/dvr/${id}`, params)

      return data
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/hanwha/dvr/${id}`)

      return data
    },
    clear({ commit }) {
      commit('setData', [])
    }
  },
}
